import React, { useMemo } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { useTheme } from 'react-native-paper';
import QText from './QText';
import { showDateTimeUTCtoLocal } from '../utils';
import LinkButton from './LinkButton';
import Hyperlink from 'react-native-hyperlink';
import CloseIcon from './Icons/CloseIcon';
const NotificationCard = ({
  item,
  onCardClick,
  onDeleteClick,
  onAcceptClick,
}) => {
  const theme = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);
  const { title, body, is_read, added_at } = item;
  return (
    <>
      <TouchableOpacity
        style={styles.container}
        activeOpacity={0.8}
        onPress={() => onCardClick(item)}
      >
        <>
          <View style={styles.inlineView}>
            <View style={{ width: '100%' }}>
              <QText style={styles.notificationTitle}>{title}</QText>
              <View>
                <Hyperlink
                  linkDefault
                  linkStyle={{ textDecoration: 'underline', width: '100%' }}
                >
                  <QText style={styles.notificationBody}>{body}</QText>
                </Hyperlink>
              </View>
              {item?.notification_data?.notification_url && (
                <View>
                  <LinkButton
                    onPress={() => {
                      onAcceptClick(item);
                    }}
                    title={'Click here'}
                  />
                </View>
              )}
              <View style={{ flexDirection: 'row', marginTop: 10 }}>
                <QText style={styles.notificationDate}>
                  {showDateTimeUTCtoLocal(added_at)}
                </QText>
              </View>
            </View>
          </View>

          {!is_read && <View style={styles.newDot} />}

          <TouchableOpacity
            style={styles.deleteIcon}
            onPress={() => onDeleteClick(item.id)}
          >
            <CloseIcon
              width={15}
              height={15}
              color={theme.colors.disabledIconColor}
            />
          </TouchableOpacity>
        </>
      </TouchableOpacity>
    </>
  );
};

const createStyles = (theme) =>
  StyleSheet.create({
    container: {
      width: '100%',
      borderWidth: 1,
      borderColor: theme.colors.borderColor,
      borderRadius: 8,
      backgroundColor: theme.colors.onBackgroundDark,
      padding: 12,
      minHeight: 80,
      marginBottom: 12,
      justifyContent: 'center',
      position: 'relative',
    },
    inlineView: {
      flexDirection: 'row',
      // alignItems: 'center'
    },
    inlineBlock: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    newDot: {
      position: 'absolute',
      top: 15,
      right: 15,
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: '#4CAF50',
    },
    textView: {
      flexDirection: 'column',
      paddingLeft: 10,
    },
    notificationTitle: {
      fontSize: 17,
      color: theme.colors.primaryText,
      fontWeight: '500',
      marginBottom: 4,
    },
    notificationBody: {
      fontSize: 14,
      color: theme.colors.secondaryText,
      lineHeight: 20,
      marginBottom: 8,
    },
    notificationDate: {
      fontSize: 12,
      color: theme.colors.tertiaryText || theme.colors.disabledIconColor,
      textAlign: 'left',
    },
    deleteIcon: { position: 'absolute', top: 15, right: 15 },
  });
export default NotificationCard;
